// src/services/adminSessions.js
//
// Domaine Admin — sessions de l’administrateur connecté
// Contrat strict Phase 0.2 (Worker Admin).

import { apiFetch } from './adminHttp';

/**
 * GET /admin/sessions
 * Liste des sessions actives de l’admin connecté.
 * Tri backend : created_at DESC. Pas de pagination.
 */
export async function getSessions() {
  return apiFetch('/admin/sessions', {
    method: 'GET',
  });
}

/**
 * POST /admin/sessions/revoke
 * Body : { session_id: string }
 */
export async function revokeSession(sessionId) {
  return apiFetch('/admin/sessions/revoke', {
    method: 'POST',
    body: JSON.stringify({ session_id: String(sessionId) }),
  });
}

/**
 * POST /admin/sessions/revoke-others
 * Aucun body métier. Révoque toutes les sessions actives sauf la courante.
 */
export async function revokeOtherSessions() {
  return apiFetch('/admin/sessions/revoke-others', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/**
 * POST /admin/sessions/revoke-admin
 * Body : { administrateur_id: string }
 * Réservé Super Admin (niveau_autorite_id === 1) côté Worker.
 */
export async function revokeAdminSessions(administrateurId) {
  return apiFetch('/admin/sessions/revoke-admin', {
    method: 'POST',
    body: JSON.stringify({ administrateur_id: String(administrateurId) }),
  });
}
